import React from "react";
import { highlightText } from "../../util/highlightText";
import { IContentLinkProps } from "../../types/suggestion-items";
import { ITelemetryData } from "../../types/telemetry";
import { sendTelemetryData } from "../../util/telemetry";
import { useNavigationContext } from "../common/contexts";

const ContentLink = (props: IContentLinkProps) => {
    const { handleMouseSelect, handleMouseDeselect, handleTouched } = useNavigationContext();

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        handleTouched(props.contentLink.navIndex);
        recordContentLinkUsed();
        window.location.href = props.contentLink.target;
    };

    const recordContentLinkUsed = () => {
        const data: ITelemetryData = {
            correlationId: props.searchInfo.pageViewLogDataId,
            culture: props.searchInfo.culture,
            portal: props.searchInfo.portal,
            searchTerm: props.searchInfo.searchTerm,
            shortLink: props.contentLink.shortLink,
            suggestion: props.contentLink.title,
            contentType: props.contentLink.type
        };
        sendTelemetryData(data, props.searchInfo.trackingEndpoint);
    };

    return props.contentLink.isHeadline ? (
        <li
            className={`suggestions-text ${props.contentLink.type} not-selectable`}
            key={props.contentLink.navIndex}
            ref={props.setRef}
        >
            {props.contentLink.title}
        </li>
    ) : (
        <li
            className={`suggestion-item ${props.contentLink.type}`}
            key={props.contentLink.navIndex}
            ref={props.setRef}
            onMouseEnter={() => handleMouseSelect(props.contentLink.navIndex)}
            onMouseLeave={handleMouseDeselect}
        >
            <a
                href={props.contentLink.target}
                onClick={handleClick}
                data-testid={`ssw-suggested-${props.contentLink.type}-${props.contentLink.anchorIndex}`}
                data-semantic-id={`ssw-suggested-${props.contentLink.type}-${props.contentLink.anchorIndex}`}
            >
                {highlightText(props.contentLink.title, props.searchInfo.searchTerm)}
            </a>
        </li>
    );
};

export default ContentLink;
